import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'

// Components
import PageInfo from '../../pageinfo/PageInfo'
import WorkOverview from './workoverview/WorkOverview'
import WorkDetails from './workdetails/WorkDetails'

// CSS
import './Work.css'

class Work extends Component {

    static propTypes = {
        projects: PropTypes.array.isRequired,
        categories: PropTypes.array.isRequired,
        selectedCategory: PropTypes.string,
        onSelectCategory: PropTypes.func.isRequired
    }

    render() {
        return (
            <div className="work">

                <PageInfo
                    title={'Work'}
                    description={"Marjolein Varekamp Children's books & design"}
                />

                <Switch>
                    <Route exact path='/' render={() => <WorkOverview projects={this.props.projects} categories={this.props.categories} selectedCategory={this.props.selectedCategory} onSelectCategory={this.props.onSelectCategory} />} />
                    <Route exact path='/work' render={() => <WorkOverview projects={this.props.projects} categories={this.props.categories} selectedCategory={this.props.selectedCategory} onSelectCategory={this.props.onSelectCategory} />} />
                    <Route path='/work/:string' component={WorkDetails} />
                </Switch>
            </div>
        )
    }
}

export default Work;





// WEBPACK FOOTER //
// ./src/components/main/work/Work.js